export const activeDataConfigRoutes = {
  DEFAULT: '/introduction',
  PRODUCTS: '/products',
  SERVICES: '/services',
  TEAMS: '/teams',
  PORTFOLIOS: '/portfolios',
  TESTIMONIALS: '/testimonials',
  EVENTS: '/events',
  CONTACTS: '/contacts',
};
